/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from "react";
import { X, Lock, CheckCircle, Clock, AlertCircle } from "lucide-react";
import { formatCurrency } from "../../utils/constants";

const ViewDetailsModal = ({
  selectedPayment,
  showViewModal,
  setShowViewModal,
  getStatusBadge,
}) => {
  const renderIcon = () => {
    const status = selectedPayment.status?.toLowerCase();
    if (status === "paid" || status === "success") {
      return (
        <div className="w-16 h-16 bg-emerald-100 dark:bg-emerald-900/30 rounded-full flex items-center justify-center">
          <CheckCircle className="text-emerald-600 dark:text-emerald-400" size={32} />
        </div>
      );
    }
    if (status === "overdue") {
      return (
        <div className="w-16 h-16 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center">
          <AlertCircle className="text-red-600 dark:text-red-400" size={32} />
        </div>
      );
    }
    return (
      <div className="w-16 h-16 bg-yellow-100 dark:bg-yellow-900/30 rounded-full flex items-center justify-center">
        <Clock className="text-yellow-600 dark:text-yellow-400" size={32} />
      </div>
    );
  };

  return (
    showViewModal &&
    selectedPayment && (
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
        <div className="bg-card dark:bg-dark-surface rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in-95 duration-200">
          <div className="p-6 border-b border-gray-100 dark:border-dark-border flex justify-between items-center">
            <h3 className="text-lg font-bold text-text dark:text-dark-text flex items-center gap-2">
              <Lock size={18} /> Payment Details
            </h3>
            <button onClick={() => setShowViewModal(false)}>
              <X size={20} className="text-gray-400 dark:text-dark-muted" />
            </button>
          </div>
          <div className="p-6">
            <div className="space-y-4">
              <div className="flex items-center justify-center mb-4">
                {renderIcon()}
              </div>
              <div>
                <p className="text-sm text-gray-500 dark:text-dark-muted mb-1">
                  Client
                </p>
                <p className="font-medium text-text dark:text-dark-text">
                  {selectedPayment.name}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500 dark:text-dark-muted mb-1">
                  Total Amount
                </p>
                <p className="font-medium text-text dark:text-dark-text">
                  {formatCurrency(selectedPayment.amountToPay || selectedPayment.amount)}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500 dark:text-dark-muted mb-1">
                  Amount Paid
                </p>
                <p className="font-medium text-text dark:text-dark-text text-emerald-600 dark:text-emerald-400">
                  {formatCurrency(selectedPayment.totalPaid)}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500 dark:text-dark-muted mb-1">
                  Status
                </p>
                <div className="mt-1">
                  {getStatusBadge(selectedPayment.status)}
                </div>
              </div>
              <div>
                <p className="text-sm text-gray-500 dark:text-dark-muted mb-1">
                  Due Date
                </p>
                <p className="font-medium text-text dark:text-dark-text">
                  {selectedPayment.displayDueDate}
                </p>
              </div>
              {selectedPayment.description && (
                <div>
                  <p className="text-sm text-gray-500 dark:text-dark-muted mb-1">
                    Description
                  </p>
                  <p className="font-medium text-text dark:text-dark-text">
                    {selectedPayment.description}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default ViewDetailsModal;
